/* src/app/components/controls/sem-many-to-one-control/sem-many-to-one-control.component.css */
.m2o-inline {
  position: relative;
  text-align: left;
  min-width: 220px;
  font-family: Inter, sans-serif;
  font-size: 13px;
  line-height: 1.4;
  color: #0f172a;
}
.m2o-inline-input {
  width: 100%;
  box-sizing: border-box;
}
.m2o-inline-inputwrap {
  position: relative;
  flex: 1 1 100%;
  width: 100%;
}
.m2o-inline-input.m2o-inline-input-x {
  padding-right: 30px;
}
.m2o-inline-rowx {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
}
.m2o-inline-value {
  flex: 1 1 100%;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 6px;
  box-sizing: border-box;
  height: 36px;
  margin-top: 4px;
  padding: 0 8px 0 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  font-weight: 500;
}
.m2o-inline-readonly {
  flex: 1 1 100%;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  box-sizing: border-box;
  margin-top: 4px;
  padding: 10px 16px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #fff;
}
.m2o-inline-link {
  cursor: pointer !important;
}
.m2o-inline-text {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.m2o-inline-clickable {
  cursor: text;
}
.m2o-inline-btn {
  flex: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  margin-left: 2px;
  padding: 0;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  font-size: 18px;
  line-height: 1;
  color: #1e293b;
}
.m2o-inline-btn:hover {
  background: #eef3fc;
  border-color: #3b6fd8;
  color: #1d4ed8;
}
.m2o-inline-btn:focus-visible {
  outline: 2px solid #3b6fd8;
  outline-offset: 1px;
}
.m2o-inline-list {
  position: absolute;
  z-index: 1000;
  left: 0;
  right: 0;
  top: 100%;
  margin: 2px 0 0;
  padding: 4px 0;
  list-style: none;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12);
  max-height: 360px;
  overflow-y: auto;
}
.m2o-inline-hit,
.m2o-inline-advanced,
.m2o-inline-empty {
  padding: 6px 12px;
}
.m2o-inline-hit,
.m2o-inline-advanced {
  cursor: pointer;
}
.m2o-inline-active {
  background: #eef3fc;
}
.m2o-inline-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.m2o-inline-subtitle {
  font-size: 12px;
  color: #6b7380;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.m2o-inline-advanced {
  border-top: 1px solid #eceff3;
  color: #3b6fd8;
}
.m2o-inline-empty {
  color: #8a919c;
}
.m2o-inline-error {
  margin-top: 4px;
  font-size: 12px;
  color: #c0392b;
}
.m2o-inline-added {
  margin-left: 8px;
  font-size: 11px;
  color: #6b7280;
  text-transform: lowercase;
}
/*# sourceMappingURL=sem-many-to-one-control.component.css.map */
